export default __webpack_public_path__ + "static/media/trash.b72ee1f9.svg";